import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@rainbow-me/rainbowkit/styles.css';
import { RainbowKitProvider, useConnectModal } from '@rainbow-me/rainbowkit';
import { useAccount } from 'wagmi';
import { createContext, useContext, useEffect } from 'react';
import React from 'react';
import { ChainType, ConnectionState } from './types';
import { useMultichainWalletSwitcher } from './MultichainWalletSwitcher';
const EthereumWalletContext = createContext({
    isConnected: false,
    address: undefined,
});
export const useEthereumWallet = () => useContext(EthereumWalletContext);
function ConnectionManager({ chains }) {
    const { selectedChain, setSelectedChain, chains: modalChains, walletConnections, _forceUpdate, registerChains, setWalletConnection, } = useMultichainWalletSwitcher();
    const account = useAccount();
    const { openConnectModal } = useConnectModal();
    const { isConnected, isConnecting, isDisconnected } = useAccount();
    useEffect(() => {
        registerChains(chains.map((chain) => ({
            ...chain,
            type: ChainType.Ethereum,
        })));
    }, [registerChains, chains]);
    useEffect(() => {
        if (isConnected) {
            setWalletConnection(ChainType.Ethereum, ConnectionState.Connected);
        }
        else if (isConnecting) {
            setWalletConnection(ChainType.Ethereum, ConnectionState.Connecting);
        }
        else if (isDisconnected) {
            setWalletConnection(ChainType.Ethereum, ConnectionState.Disconnected);
        }
    }, [isConnected, isConnecting, isDisconnected, setWalletConnection]);
    useEffect(() => {
        if (walletConnections.ethereum === ConnectionState.Disconnected &&
            selectedChain?.type === ChainType.Ethereum) {
            openConnectModal?.();
        }
    }, [selectedChain, openConnectModal, walletConnections.ethereum, _forceUpdate]);
    useEffect(() => {
        if (account.chain) {
            const chain = modalChains.find((chain) => chain.id === account.chain?.id) ?? null;
            setSelectedChain(chain);
        }
    }, [account.chain, setSelectedChain, modalChains]);
    return null;
}
export function EVMWalletProvider({ children, chains, ...rainbowKitProps }) {
    const { selectedChain } = useMultichainWalletSwitcher();
    const chain = chains.find((chain) => chain.id === selectedChain?.id) ?? undefined;
    return (_jsxs(RainbowKitProvider, { initialChain: chain?.id, ...rainbowKitProps, children: [_jsx(ConnectionManager, { chains: chains }), children] }));
}
